export default "__VITE_ASSET__DnBkyL5U__"